import React, { useEffect, useState } from 'react';
import {
    Popover,
    Select,
    MenuItem,
    Box,
    Typography,
    FormControl,
    InputLabel,
    Button,
} from '@mui/material';
 
const CustomTimePicker = ({
    value = '',
    onChange,
    format = '24',
    label = 'Time',
    interval = 1,
    helperText = '',
    error = false
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const initialHour = value?.split(':')[0] || '00';
    const initialMinute = value?.split(':')[1] || '00';
 
    const [hour, setHour] = useState(initialHour);
    const [minute, setMinute] = useState(initialMinute);
    const [ampm, setAmpm] = useState('AM');
 
    const open = Boolean(anchorEl);
 
    const handleTriggerClick = (event) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
 
    const handleClose = () => {
        setAnchorEl(null);
    };
 
    const generateOptions = (max, interval = 1) =>
        Array.from({ length: Math.ceil(max / interval) }, (_, i) =>
            String(i * interval).padStart(2, '0')
        );
 
    const handleOk = () => {
        let finalHour = hour;
 
        if (format === '12') {
            let h = parseInt(hour, 10);
            if (ampm === 'PM' && h < 12) h += 12;
            if (ampm === 'AM' && h === 12) h = 0;
            finalHour = String(h).padStart(2, '0');
        }
 
        const result = `${finalHour}:${minute}`;
        if (onChange) onChange(result);
        handleClose();
    };
 
    useEffect(() => {
        const [newHour = '00', newMinute = '00'] = value?.split(':') || [];
        setHour(newHour);
        setMinute(newMinute);
    }, [value]);
 
    return (
        <>
            <FormControl fullWidth variant sx={{ m: 1 }} error={error}>
                <InputLabel>{label}</InputLabel>
                <Select
                    label={label}
                    value={value || ''}
                    onMouseDown={handleTriggerClick}
                    onChange={() => { }}
                    open={false}
                    variant='standard'
                >
                    <MenuItem value={value || ''}>{value || `Select ${label}`}</MenuItem>
                </Select>
                {helperText && <Typography variant="caption" color={error ? "error" : "textSecondary"} sx={{ ml: 0 }}>{helperText}</Typography>}
            </FormControl>
 
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 200 }}>
                    <Typography variant="subtitle1">Select {label}</Typography>
 
                    <Box display="flex" gap={2}>
                        <FormControl fullWidth>
                            <InputLabel>Hour</InputLabel>
                            <Select
                                value={hour}
                                label="Hour"
                                onChange={(e) => setHour(e.target.value)}
                            >
                                {generateOptions(format === '12' ? 12 : 24).map((h) => {
                                    const value = h === '00' && format === '12' ? '12' : h;
                                    return (
                                        <MenuItem key={value} value={value}>
                                            {value}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
 
                        <FormControl fullWidth>
                            <InputLabel>Minute</InputLabel>
                            <Select
                                value={minute}
                                label="Minute"
                                onChange={(e) => setMinute(e.target.value)}
                            >
                                {generateOptions(60, interval).map((m) => (
                                    <MenuItem key={m} value={m}>
                                        {m}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
 
                    {format === '12' && (
                        <FormControl fullWidth>
                            <InputLabel>AM/PM</InputLabel>
                            <Select
                                value={ampm}
                                label="AM/PM"
                                onChange={(e) => setAmpm(e.target.value)}
                            >
                                <MenuItem value="AM">AM</MenuItem>
                                <MenuItem value="PM">PM</MenuItem>
                            </Select>
                        </FormControl>
                    )}
 
                    <Button variant="contained" onClick={handleOk}>
                        OK
                    </Button>
                </Box>
            </Popover>
        </>
    );
};
 
export default CustomTimePicker;
 
 